import { render, staticRenderFns } from "./allTestPaper.vue?vue&type=template&id=23adc904&scoped=true"
import script from "./allTestPaper.vue?vue&type=script&lang=js"
export * from "./allTestPaper.vue?vue&type=script&lang=js"
import style0 from "./allTestPaper.vue?vue&type=style&index=0&id=23adc904&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23adc904",
  null
  
)

export default component.exports